export const UserSessionConstants = {
    LOGIN_USER:'LOGIN_USER',
    FETCHING_USER:'FETCHING_USER',
    FETCHING_USER_FAILURED:'FETCHING_USER_FAILURED',
    ESTABLISH_USER_SESSION:'ESTABLISH_USER_SESSION',
    CLOSED_USER_SESSION:'CLOSED_USER_SESSION'
}